export default function PrintComponent({ obj }) {
  const iframe = document.createElement("iframe");
  iframe.style.position = "absolute";
  iframe.style.width = "0";
  iframe.style.height = "0";
  iframe.style.border = "none";

  document.body.appendChild(iframe);

  const iframeDoc = iframe.contentWindow.document;

  console.log("OBBBBBBBB: ", obj);

  iframeDoc.open();
  iframeDoc.write(
    `<html><head><style>
                    body {
                      font-family: Arial, sans-serif;
                    }
                    .print-content-container {
                      display: flex;
                      flex-direction: row;
                      justify-content: space-between;
                    }
                    .print-content {
                      width: 100%;
                      margin: 0 5px;
                      padding: 10px;
                    }
                    @media print {
                      th {
                        font-weight: normal; 
                      }
                      .page-break {
                        page-break-before: always;
                      }
                    }
                    
                    @page {
                      size: auto;   /* auto is the initial value */
                      margin: 0;     /* this affects the margin in the printer settings */
                      visibility: hidden;
                    }
                    .header-container {
                      display: flex;
                      border: 1px solid black;
                      text-align: center;
                    }
                    .header-left {
                      flex: 1;
                      border: 1px solid black;
                      display: flex;
                      align-items: center;
                      justify-content: center;
                    }
                    .header-left p {
                      margin: 0;
                    }
                    .header-right {
                      flex: 1;
                      border: 1px solid black;
                      padding: 0;
                    }
                    .header-title {
                      background-color: #c1c1c1;
                      padding: 0.5rem;
                      font-size: 11px;
                      font-weight: bold;
                      -webkit-print-color-adjust: exact; /* For Webkit browsers */
                      print-color-adjust: exact; /* For standard browsers */
                    }
                    .form-group {
                      margin-bottom: .5rem;
                      border: 1px solid;
                    }
                    .border {
                      border: 1px solid black;
                      padding: 0.5rem;
                    }
                    .p-3 {
                      padding: 1rem;
                    }
                    .m-auto {
                      margin: auto;
                    }
                    .d-flex {
                      display: flex;
                    }
                    .align-items-center {
                      align-items: center;
                    }
                    .gap-1 {
                      gap: 0.25rem;
                    }
                    .row {
                      display: flex;
                      flex-wrap: wrap;
                    }
                    .labelItem{
                        display: flex; 
                        height: 2rem;
                        padding: 10px;
                    }
                    .col-lg-2 {
                      flex: 0 0 16.66667%;
                      max-width: 16.66667%;
                    }
                    .col-lg-6 {
                      flex: 0 0 50%;
                      max-width: 50%;
                    }
                    .col-lg-12 {
                      flex: 0 0 100%;
                      max-width: 100%;
                    }
                    .form-group label {
                      display: block;
                      margin-bottom: 0.5rem;
                      padding:.5rem;
                      background-color: #c1c1c1;
                      -webkit-print-color-adjust: exact; /* For Webkit browsers */
                      print-color-adjust: exact; /* For standard browsers */
                    }
                    .form-group input[type="checkbox"] {
                      margin-right: 0.5rem;
                    }
                    .white-space-nowrap {
                      white-space: nowrap;
                    }
                    table {
                      width: 100%;
                      border-collapse: collapse;
                    }
                    th, td {
                      border: 1px solid black;
                      padding: 5px;
                      text-align: left;
                    }
                  </style></head><body>
                  <div class="header-container">
                    <div class="header-left">
                      <p>
                        <b>Republic of the Philippines</b> POSITION DESCRIPTION FORM DBM-CSC Form
                        No.1 (Revised Version No.1, s.2017)
                      </p>
                    </div>
                    <div class="header-right">
                      <div class="header-title">
                        1. POSITION TITLE (as approved by authorized agency) with parenthetical
                        title
                      </div>
                      <span class="labelItem">${
                        obj ? obj.position_title : ""
                      }</span>
                    </div>
                  </div>
          
                  <div class="row border">
                    <div class="col-lg-6">
                      <!-- 2. ITEM NUMBER -->
                      <div class="form-group">
                        <label style="font-size: 12px" for="item_number">2. ITEM NUMBER</label>
                        <span class="labelItem">${
                          obj ? obj.item_number : ""
                        }</span>
                      </div>
                    </div>
                    <div class="col-lg-6">
                      <!-- 3. SALARY GRADE -->
                      <div class="form-group">
                        <label style="font-size: 12px" for="salary_grade">3. SALARY GRADE</label>
                        <span class="labelItem">${
                          obj ? obj.salary_grade : ""
                        }</span>
                      </div>
                    </div>
          
                    <!-- 4. FOR LOCAL GOVERNMENT POSITION, ENUMERATE GOVERNMENTAL UNIT AND CLASS -->
                    <div class="m-auto">
                      <div class="form-group">
                        <label style="font-size: 12px" for="local_government">
                          4. FOR LOCAL GOVERNMENT POSITION, ENUMERATE GOVERNMENTAL UNIT AND CLASS
                        </label>
                        <div class="row m-auto p-3">
                          ${[
                            "Province",
                            "City",
                            "Municipality",
                            "First_Class",
                            "Second_Class",
                            "Third_Class",
                            "Fourth_Class",
                            "Fifth_Class",
                            "Sixth_Class",
                            "Seventh_Class",
                            "Special",
                          ]
                            .map(
                              (label) => `
                                <div class="col-lg-2 d-flex align-items-center gap-1 white-space-nowrap">
                                  <input type="checkbox" disabled="true" ${
                                    obj && obj[label] ? "checked" : ""
                                  } />
                                  <span style="font-size: 13px;">
                                    ${
                                      {
                                        First_Class: "1st Class",
                                        Second_Class: "2nd Class",
                                        Third_Class: "3rd Class",
                                        Fourth_Class: "4th Class",
                                        Fifth_Class: "5th Class",
                                        Sixth_Class: "6th Class",
                                        Seventh_Class: "7th Class",
                                      }[label] || label
                                    }
                                  </span>
                                </div>`
                            )
                            .join("")}
                        </div>
                      </div>
                    </div>
          
                    ${[
                      "agencyOrLocal_government",
                      "region",
                      "office",
                      "division",
                      "section",
                      "unit",
                      "cluster",
                      "workstation",
                    ]
                      .map(
                        (label, index) => `
                          <div style="width: 50%">
                            <div class="form-group">
                              <label style="font-size: 12px" for="${label}">${
                          index + 5
                        }. ${
                          label === "cluster"
                            ? "Plantilla"
                            : label.replace(/_/g, " ").toUpperCase()
                        }</label>
                              <span class="labelItem">${
                                obj && obj[label] ? obj[label] : ""
                              }</span>
                            </div>
                          </div>`
                      )
                      .join("")}

                        ${[
                          "present_approp_act",
                          "prev_approp_act",
                          "salary_authorized",
                          "other_compensation",
                        ]
                          .map(
                            (label, index) => `
                          <div style="width: 25%">
                            <div class="form-group">
                              <label style="font-size: 12px" for="${label}">${
                              index + 13
                            }. ${label.replace(/_/g, " ").toUpperCase()}</label>
                              <span class="labelItem">${
                                obj ? obj[label] : ""
                              }</span>
                            </div>
                          </div>`
                          )
                          .join("")}


                          ${["immediate_supervisor", "next_higher_supervisor"]
                            .map(
                              (label, index) => `
                          <div style="width: 50%">
                            <div class="form-group">
                              <label style="font-size: 12px" for="${label}">${
                                index + 17
                              }. ${label
                                .replace(/_/g, " ")
                                .toUpperCase()}</label>
                              <span class="labelItem">${
                                obj ? obj[label] : ""
                              }</span>
                            </div>
                          </div>`
                            )
                            .join("")}
                            <div style="width: 100%">
                      <div class="form-group">
                        <label style="font-size: 12px">
                          19. POSITION TITLE, AND ITEM OF THOSE DIRECTLY SUPERVISED
                        </label>
                        <table style="border-collapse: collapse; width: 100%; margin-bottom: 10px; text-align: left;">
                          <thead>
                            <tr>
                              <th style="font-weight: bold">Position</th>
                              <th style="font-weight: bold">Item Number</th>
                            </tr>
                          </thead>
                          <tbody>
                            ${obj.positionRows
                              .map(
                                (label, index) => `
                              <tr key=${index}>
                                <td>${label.title}</td>
                                <td>${label.itemNum}</td>
                              </tr>
                            `
                              )
                              .join("")}
                            ${Array.from({
                              length: Math.max(5 - obj.positionRows.length, 0),
                            })
                              .map(
                                (_, index) => `
                                <tr key=${obj.positionRows.length + index}>
                                  <td>&nbsp;</td>
                                  <td>&nbsp;</td>
                                </tr>
                              `
                              )
                              .join("")}
                          </tbody>
                        </table>
                      </div>
                    </div>

                    <div style="width: 100%">
                      <div class="form-group">
                        <label style="font-size: 12px">20. MACHINE, EQUIPMENT, TOOLS, ETC., USED REGULARLY IN PERFORMANCE OF WORK</label>
                        <span class="labelItem">${obj.machine_tools}</span>
                      </div>
                    </div>
                  </div>

                  <div class="page-break"></div>

                  <div class="header-container" style="padding: .5rem; margin-top: 1rem; text-align:left">
                    <div style="width: 100%">
                      <div class="form-group">
                        <label style="font-size: 12px">21. CONTACTS / CLIENTS / STAKEHOLDERS</label>
                        <div class="row">
                          ${[
                            {
                              header: "21a. Internal",
                              rows: [
                                "Executive",
                                "Supervisors",
                                "NonSupervisors",
                                "Staff",
                              ],
                            },
                            {
                              header: "21b. External",
                              rows: ["General", "Agencies"],
                            },
                          ]
                            .map((section, index) => {
                              const displayLabel = {
                                Executive: "Executive/ Managerial",
                                Supervisors: "Supervisors",
                                NonSupervisors: "Non-Supervisors",
                                Staff: "Staff",
                                General: "General Public",
                                Agencies: "Other Agencies",
                              };
                              return `
                                <div class="p-0 col-lg-6" key=${index}>
                                  <table>
                                    <thead>
                                      <tr>
                                        <th>${section.header}</th>
                                        <th>Occasional</th>
                                        <th>Frequent</th>
                                      </tr>
                                    </thead>
                                    <tbody>
                                      ${section.rows
                                        .map(
                                          (row) => `
                                          <tr>
                                            <td style="width: 50%">${
                                              displayLabel[row]
                                            }</td>
                                            <td style="width: 25%"><input type="checkbox" ${
                                              obj[row.toLowerCase()]?.Occasional
                                                ? "checked"
                                                : ""
                                            } disabled></td>
                                            <td style="width: 25%"><input type="checkbox" ${
                                              obj[row.toLowerCase()]?.Frequent
                                                ? "checked"
                                                : ""
                                            } disabled></td>
                                          </tr>
                                        `
                                        )
                                        .join("")}
                                    </tbody>
                                  </table>
                                  ${
                                    index === 1
                                      ? `
                                      <div class="d-flex justify-content-center align-items-center p-2">
                                        <div style="display: flex; align-items:center">
                                          <span class="labelItem">Others: </span>
                                          <span class="labelItem">${
                                            obj.otherStakeholder || ""
                                          }</span>
                                        </div>
                                      </div>
                                    `
                                      : ""
                                  }
                                </div>
                              `;
                            })
                            .join("")}
                        </div>
                      </div>
                      <div style="100%">
                      <div class="form-group">
                        <label style="font-size: 12px">22. WORKING CONDITION</label>
                        <div class="row">
                          <div class="col-lg-6 p-0">
                            <table>
                              <tbody>
                                ${["Office Work", "Field Work"]
                                  .map(
                                    (row) => `
                                    <tr>
                                      <td style="width: 50%">${row}</td>
                                      <td style="width: 25%"><input type="checkbox" ${
                                        obj[
                                          row.replace(/\s+/g, "").toLowerCase()
                                        ]?.Occasional
                                          ? "checked"
                                          : ""
                                      } disabled></td>
                                      <td style="width: 25%"><input type="checkbox" ${
                                        obj[
                                          row.replace(/\s+/g, "").toLowerCase()
                                        ]?.Frequent
                                          ? "checked"
                                          : ""
                                      } disabled></td>
                                    </tr>`
                                  )
                                  .join("")}
                              </tbody>
                            </table>
                          </div>
                          <div class="col-lg-6 d-flex justify-content-center align-items-center p-2">
                            <div style="display: flex; align-items:center">
                            <span class="labelItem">Others: </span>
                                          <span class="labelItem">${
                                            obj.otherWorking || ""
                                          }</span>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    ${["UnitOfSection", "JobSummary"]
                      .map(
                        (label, index) => `
                        <div style="width: 100%" key=${index}>
                          <div class="form-group">
                            <label style="font-size: 12px">
                              ${index + 23}. ${
                          {
                            UnitOfSection:
                              "BRIEF DESCRIPTION OF THE GENERAL FUNCTION OF THE UNIT OR SECTION",
                            JobSummary:
                              "BRIEF DESCRIPTION OF THE GENERAL FUNCTION OF THE POSITION (Job Summary)",
                          }[label] || label.toUpperCase()
                        }
                            </label>
                            <div>
                            <span class="labelItem">${
                              obj[label.toLowerCase()] || ""
                            }</span>
                            </div>
                          </div>
                        </div>`
                      )
                      .join("")}


                      <div style="width: 100%">
                    <div class="form-group">
                      <label style="font-size: 12px">25. QUALIFICATION STANDARDS</label>
                      <div class="row">
                        ${[
                          "Education",
                          "Experience",
                          "Training",
                          "Eligibility",
                          "Core Competencies",
                          "Competency Level",
                          "Leadership Competencies",
                          "Level Competency",
                        ]
                          .map((label, index) => {
                            const letter = String.fromCharCode(97 + index);
                            return `
                              <div style="${
                                index <= 3 ? "width: 25%" : "width: 50%"
                              }" key=${index}>
                                <div class="form-group">
                                  <label style="font-size: 12px">25${letter}. ${label}</label>
                                  <div>
                                  <span class="labelItem">${
                                    obj[
                                      label.replace(/\s+/g, "").toLowerCase()
                                    ] || ""
                                  }</span>
                                  </div>
                                </div>
                              </div>`;
                          })
                          .join("")}

                          <div style="width: 100%">
                    <div class="form-group">
                      <label style="font-size: 12px">26. STATEMENT OF DUTIES AND RESPONSIBILITIES (Technical Competencies)</label>
                      <div class="p-0">


                      <table style="border-collapse: collapse; width: 100%; margin-bottom: 10px; text-align: left;">
                          <thead>
                            <tr>
                              <th style="font-weight: bold">Percentage of Working Time</th>
                              <th style="font-weight: bold">Duties and Responsibilities</th>
                              <th style="font-weight: bold">Competency Level</th>
                            </tr>
                          </thead>
                          <tbody>
                            ${obj.responsibilityRows
                              .map(
                                (row, index) => `
                                <tr key=${index}>
                                  <td>${row.percentage}</td>
                                  <td>${row.duties}</td>
                                  <td>${row.competency}</td>
                                </tr>`
                              )
                              .join("")}
                            ${Array.from({
                              length: Math.max(
                                5 - obj.responsibilityRows.length,
                                0
                              ),
                            })
                              .map(
                                (_, index) => `
                                <tr key=${
                                  obj.responsibilityRows.length + index
                                }>
                                  <td>&nbsp;</td>
                                  <td>&nbsp;</td>
                                  <td>&nbsp;</td>
                                </tr>
                              `
                              )
                              .join("")}
                          </tbody>
                        </table>

                      </div>
                    </div>
                  </div>
                      </div>
                    </div>
                  </div>


                  </div>
                    </div>
                  </div>
                  
<div class="page-break"></div>

                  <div class="header-container" style="padding: .5rem; margin-top: 1rem; text-align:left;">
                  <div style="width: 100%">
                    <div class="form-group">
                      <label style="font-size: 12px">27. ACKNOWLEDGMENT AND ACCEPTANCE:</label>
                      <div style="height: 10rem" class="d-grid">
                        <div style="display: flex; text-align:center; padding: 2rem">
                            <span style="font-size: 14px">
                          I have received a copy of this position description. It has been discussed with me and I have freely chosen to comply with the performance and behavior/conduct expectations contained herein.
                        </span>
                        </div>
                        <div style="display: flex;
                         align-items: end; justify-content: space-evenly; height: 3rem">
                          <span style="font-size: 10px">Employee's Name, Date and Signature</span>
                          <span style="font-size: 10px">Supervisor's Name, Designation, Date and Signature</span>
                        </div>
                      </div>
                    </div>
                  </div>
                  </div>

                  </body></html>`
  );
  iframeDoc.close();

  iframe.contentWindow.focus();
  iframe.contentWindow.print();

  // Remove the iframe after printing
  document.body.removeChild(iframe);
}
